import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Context } from 'src/app/shared/models/context';
import { Message, Payment, PrivilegeType, Salary } from 'src/app/shared/models/domain';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { DataService } from 'src/app/shared/services/data.service';
import { EmployeeService } from 'src/app/shared/services/employee.service';
import { SalaryCrudComponent } from '../salary-crud/salary-crud.component';
import { PaymentCrudComponent } from '../../payment/payment-crud/payment-crud.component';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-salary-list',
  templateUrl: './salary-list.component.html',
  styleUrls: ['./salary-list.component.scss'],
})
export class SalaryListComponent implements OnInit {
  public salaries: Salary[] = [];
  public context: Context;
  public payment: Payment;
  public isLoading: boolean = true;
  public searchKeyword: string = "";
  public privilege: PrivilegeType;
  private subscription: any;
  public fromDate: string;
  public toDate: string;
  public salaryDate: string;

  constructor(
    private modalService: NgbModal,
    private authService: AuthService,
    private commonService: CommonService,
    private employeeService: EmployeeService,
    private dataService: DataService,
    private datePipe: DatePipe

  ) { }

  ngOnInit(): void {
    this.dataService.privilege().subscribe(privilege => { this.privilege = this.commonService.getPrivileges(privilege) });
    this.subscription = this.authService.getContext().subscribe(context => {
      if (context?.employeeId) {
        this.context = context;
        this.getSalaries();
      }
    });
    const today = new Date();
    this.salaryDate = today.toISOString().split('T')[0];
    this.payment = {} as Payment;
    this.getSalaries();
  }

  public onSalaryChange() {
    this.getSalaries();
  }

  private getSalaries(clear: boolean = true) {
    if (this.context?.employeeId) {
      if (clear) {
        this.isLoading = true;
        this.salaries = [];
      }
      if (!this.salaryDate) {
        // this.commonService.setToastr(500, "Please provide the salary date")
        return;
      }
      const date = this.datePipe.transform(this.salaryDate, 'dd-MM-yyyy');
      this.employeeService.getSalaries(this.context.employeeId, null, date).subscribe({
        next: (salaries: Salary[]) => {
          this.salaries = salaries.sort((a, b) => {
            return (b.active ? 1 : 0) - (a.active ? 1 : 0);
          });
          // this.salaries = salaries.sort((a, b) => a.id - b.id);
          this.isLoading = false;
        },
        error: (error: HttpErrorResponse) => {
          this.isLoading = false;
          this.commonService.setToastr(500, error?.error?.name || error.error);
        }
      });
    } else {
      this.isLoading = false;
    }
  }

  public upsertSalary(salary?: Salary) {
    if (!this.privilege.canEdit) return;
    const modalRef = this.modalService.open(SalaryCrudComponent, { size: 'lg', backdrop: 'static' });
    modalRef.componentInstance.salary = salary;
    modalRef.componentInstance.context = this.context;
    modalRef.componentInstance.salaries = this.salaries.filter(t => t.id !== salary?.id);
    modalRef.componentInstance.passEntry.subscribe((response: Salary) => {
      if (response) {
        this.getSalaries(true);
      }
    });
  }

  

  public toggleSalaryStatus(salary: Salary) {
    if (!this.privilege.canEdit) {
      setTimeout(() => { salary.active = salary.active }, 0);
      return;
    }
    this.employeeService.toggleSalaryStatus(salary.id,salary.active).subscribe({
      next: (response: Message) => {
        if (!response.failed) {
          this.getSalaries(true)
          this.commonService.setToastr(200, response.text);
        } else {
          this.commonService.setToastr(500, response.text);
        }
      },
      error: (error: HttpErrorResponse) => {
        salary.isDeleteInProgress = false;
      },
    });
  }  

  // public upsertPayment(salary?: Salary) {
  //   if (!this.privilege.canEdit) return;
  //   if (salary) {
  //     if (salary.status == 'NIL') {
  //       this.payment.salaryDate = this.salaryDate;
  //       this.payment.salaryId = salary.id; 
  //       this.payment.status = 'DUE';
  //       this.employeeService.createPayment(this.payment).subscribe({
  //         next: (response: Message) => {
  //           if (!response.failed) {
  //             this.commonService.setToastr(200, "Payment due created  successfully");
  //           } else {
  //             this.commonService.setToastr(500, response.text);
  //           }
  //           this.getSalaries();
  //         },
  //         error: (error: HttpErrorResponse) => {
  //           this.commonService.setToastr(500, error?.error?.name || error.error);
  //         }
  //       })
  //     } else if (salary.status == 'DUE' && salary.paymentId) {
  //       this.employeeService.getPayment(salary.paymentId).subscribe({
  //         next: (payment : Payment) => {
  //           this.payment = payment;
  //           const modalRef = this.modalService.open(PaymentCrudComponent, {size: 'lg', backdrop: 'static'});
  //           modalRef.componentInstance.payment = this.payment;
  //           modalRef.componentInstance.sid = salary.id;
  //           modalRef.componentInstance.salaryDate = this.salaryDate;
  //           modalRef.result.finally(() => {
  //             this.getSalaries();
  //           });
  //         },
  //         error: (error: HttpErrorResponse) => {
  //           this.commonService.setToastr(500, error?.error.name || error.error)
  //         }
  //       })  
  //     }
  //   }
  // }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  getFormattedDate(dateString: string): string {
    return dateString ? dateString.slice(0, 10) : '';
  }
}
